import {
    TableSettingsState,
    useTableSettingsStore,
} from 'bpm/components/SpecTable/settings/store'
import {
    ListingPageStoreType,
    useListingPageStore,
} from '../ProductCardManagementPage/store'

const useTablePageStore = () => {
    const hasNextPage = useListingPageStore(
        (state: ListingPageStoreType) => state.hasNextPage
    )
    const setShowBulkActions = useListingPageStore(
        (state: ListingPageStoreType) => state.setShowBulkActions
    )
    const setEnableBulkActions = useListingPageStore(
        (state: ListingPageStoreType) => state.setEnableBulkActions
    )
    const setCopyMoveParams = useListingPageStore(
        (state: ListingPageStoreType) => state.setCopyMoveParams
    )
    const pinningProps = useTableSettingsStore(
        (state: TableSettingsState) => state.pinningProps
    )
    const filters = useTableSettingsStore(
        (state: TableSettingsState) => state.filters
    )
    const groupColumns = useTableSettingsStore(
        (state: TableSettingsState) => state.groupColumns
    )
    const orderBy = useTableSettingsStore(
        (state: TableSettingsState) => state.orderBy
    )
    const columnWidths = useTableSettingsStore(
        (state: TableSettingsState) => state.columnWidths
    )
    const setColumnWidths = useTableSettingsStore(
        (state: TableSettingsState) => state.setColumnWidths
    )
    const setOrderBy = useTableSettingsStore(
        (state: TableSettingsState) => state.setOrderBy
    )
    const setFilters = useTableSettingsStore(
        (state: TableSettingsState) => state.setFilters
    )
    const selectedRowIds = useTableSettingsStore(
        (state: TableSettingsState) => state.selectedRowIds
    )
    const setSelectedRowIds = useTableSettingsStore(
        (state: TableSettingsState) => state.setSelectedRowIds
    )

    return {
        columnWidths,
        hasNextPage,
        setShowBulkActions,
        setEnableBulkActions,
        setCopyMoveParams,
        pinningProps,
        filterState: filters,
        groupColumns,
        orderByState: orderBy,
        setColumnWidths,
        setOrderBy,
        setFilters,
        selectedRowIds,
        setSelectedRowIds,
    }
}

export default useTablePageStore
